import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=29546a7e&scoped=true&"
import script from "./GalleryModal.vue?vue&type=script&lang=js&"
export * from "./GalleryModal.vue?vue&type=script&lang=js&"
import style0 from "./GalleryModal.vue?vue&type=style&index=0&id=29546a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29546a7e",
  null
  
)

export default component.exports